export default __webpack_public_path__ + "static/media/supergraphic1.0e61ed2e.png";